<template>
  <div class="bg-background-light border-b-[1px] border-bw-grey">
    <div class="pt-12 pb-28 flex flex-col align-center">
      <div class="container flex flex-col justify-center text-center py-12">
        <div class="responsive-title-2 font-bold mb-4">{{ t('cosmosImprint.title') }}</div>
      </div>
      <div class="container w-100 space-y-6">
        <div class="responsive-body-medium text-left">
          <p class="font-bold">{{ t('cosmosImprint.gmbh') }}</p>
          <p class="responsive-body-medium mt-4">
            {{ t('cosmosImprint.road') }}<br />
            {{ t('cosmosImprint.city') }}<br />
            {{ t('cosmosImprint.country') }}
          </p>

          <p class="responsive-body-medium mt-6">
            <span class="font-bold">{{ t('cosmosImprint.phone') }}</span>
            <a href="tel:+4989411471900" class="text-primary-blue underline ml-2">+49 (0)89 411 47 19 00</a>
          </p>
          <p class="responsive-body-medium mt-2">
            <span class="font-bold">{{ t('cosmosImprint.mail') }}</span>
            <a href="mailto:hello@cosmosyachting.com" class="text-primary-blue underline ml-2">hello@cosmosyachting.com</a>
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">{{ t('cosmosImprint.website') }}</span>
            <a href="https://cosmosyachting.com" target="_blank" rel="noopener noreferrer" class="text-primary-blue underline ml-2">cosmosyachting.com</a>
          </p>

          <p class="responsive-body-medium mt-6">
            <span class=" font-bold">{{ t('cosmosImprint.authorizedManagingDirector') }}</span> {{ t('cosmosImprint.name') }}
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">{{ t('cosmosImprint.registerCourt') }}</span> {{ t('cosmosImprint.districtCourt') }}
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">{{ t('cosmosImprint.regNumber') }}</span> {{ t('cosmosImprint.valueOfRegNumber') }}
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">{{ t('cosmosImprint.vatIdentificationNumber') }}</span> {{ t('cosmosImprint.valueOfVatNumber') }}
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">{{ t('cosmosImprint.contentResponsibility') }}</span> {{ t('cosmosImprint.respName') }}
          </p>

          <p class="responsive-body-medium mt-6">
            <img src="@/assets/icons/svg/Action_required_16x16.svg" alt="Info icon" class="inline-block h-5 w-5 mr-2" />
            <span class=" font-bold">{{ t('cosmosImprint.disclaimer') }}</span>
            {{ t('cosmosImprint.disclaimerText') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>